import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	titleNonFinal: {
		id: 'eoc-changeboarding.transition-home.right.title-non-final',
		defaultMessage: 'Get alerts on Jira Cloud mobile',
		description: 'Title of rigth hand side of the transition home screen',
	},
	appDownloadNonFinal: {
		id: 'eoc-changeboarding.transition-home.right.app-download-non-final',
		defaultMessage: 'Get the Jira Cloud mobile app',
		description: 'Text will label if user is downloaded the app',
	},
	jiraCloudContactMethodNonFinal: {
		id: 'eoc-changeboarding.transition-home.right.jira-cloud-contact-method-non-final',
		defaultMessage: 'Add Jira Cloud mobile app as your notification method',
		description: 'Text will label if user is added JNA as contact method or not',
	},
	turnOffOgNonFinal: {
		id: 'eoc-changeboarding.transition-home.right.turn-off-og-non-final',
		defaultMessage: 'Turn off Opsgenie mobile app in your contact methods',
		description: 'Text will label if user is turn off Opsgenie mobile app or not',
	},
	numberOfUsersJnaDownloadedNonFinal: {
		id: 'eoc-changeboarding.transition-home.right.number-of-users-jna-downloaded-non-final',
		defaultMessage:
			'{numberOfUsers, plural, one {{numberOfUsers} team member} other {{numberOfUsers} team members}} already have the Jira Cloud mobile app.',
		description: 'Text will label if user is downloaded the app',
	},
	jnaAppDownloadPercentNonFinal: {
		id: 'eoc-changeboarding.transition-home.right.jna-app-download-percent-non-final',
		defaultMessage: '{percent}%',
		description: 'Text will label ratio of users downloaded the app',
	},
	doneNonFinal: {
		id: 'eoc-changeboarding.transition-home.right.done-non-final',
		defaultMessage: 'Done',
		description: 'Label of check icon',
	},
	todoNonFinal: {
		id: 'eoc-changeboarding.transition-home.right.todo-non-final',
		defaultMessage: 'To do',
		description: 'Label of empty circle icon',
	},
	documentationNonFinal: {
		id: 'eoc-changeboarding.transition-home.right.documentation-non-final',
		defaultMessage: 'Get help with shifting',
		description:
			'Title of right side of transition home screen, lists documentation links under this title',
	},
	unlockOperationsInJsmNonFinal: {
		id: 'eoc-changeboarding.transition-home.right.unlock-operations-in-jsm-non-final',
		defaultMessage: 'Set up operations and complete your shift to Jira Service Management',
		description: 'First link of right side of transition home screen, links to documentation',
	},
	numberOfUsersJnaDownloadedWithLozengeNonFinal: {
		id: 'eoc-changeboarding.transition-home.right.number-of-users-jna-downloaded-with-lozenge-non-final',
		defaultMessage:
			'<lozenge>{numberOfUsers}</lozenge> {numberOfUsers, plural, one {team member} other {team members}} already have the Jira Cloud mobile app, <lozenge>{allUsers}</lozenge> of all users',
		description: 'Text will label if user is downloaded the app',
	},
});
